import React, { useEffect, useState } from 'react';
import { ToggleObject } from '@vwfs-bronson/bronson-react';
import { JOURNEY_STATE, useApplicationState } from '../../App.state';
import { Step } from '../../../shared/interface';
import {
  getFieldValidators,
  getMM1Fields
} from '../../../shared/validation-rules/match-maker-validator';
import { Question } from '../../components/Questions';
import { adobeDataLayer } from '../../lib/adobe-analytics-data-layer/AdobeDataLayer';
import { CarType } from '../../lib/components/MatchMakerAnswersEditComponents/CarType';
import {
  EquipmentAndServices,
  Item
} from '../../lib/components/MatchMakerAnswersEditComponents/EquipmentAndServices';
import { FuelType } from '../../lib/components/MatchMakerAnswersEditComponents/FuelType';
import { Power } from '../../lib/components/MatchMakerAnswersEditComponents/Power';
import { mapOptionsToItems } from '../../lib/helpers/map-options-to-items-helpers';
import { VehicleCondition } from '../../lib/components/MatchMakerAnswersEditComponents/VehicleCondition';
import { RouterHelpers } from '../../router/router-helpers';
import { useCustomTranslation } from '../../utils/translations';
import { genericValidator } from '../MatchMakerHelper';
import MatchMakerQuestionWrapper from './MatchMakerQuestionWrapper';

interface OwnProps {
  isEditMode?: boolean;
}

export const MatchMakerQuestion1: React.FC<OwnProps> = ({ isEditMode }) => {
  const { t } = useCustomTranslation('match-maker');
  const { dispatch } = useApplicationState();
  const [showAdditionalVehicleFeatures, setShowAdditionalVehicleFeatures] = useState(false);

  const equipmentItems: Item[] = mapOptionsToItems(
    t,
    'question-pages.items.special-equipments.options'
  );

  useEffect(() => {
    dispatch({ type: 'updateJourneyStatus', journeyStatus: JOURNEY_STATE.STARTED });
    adobeDataLayer.pageViewMatchMakerQuestionPage(1, 'Vehicle preferences');
  }, [dispatch]);

  return (
    <MatchMakerQuestionWrapper
      currentStep={Step.MM1}
      isEditMode={isEditMode}
      currentPercentage={1}
      nextPage={RouterHelpers.getMatchMakerQuestionPage2Path()}
      nextButtonLabel={t('question-pages.question-page-one.next-button')}
      validate={(values) =>
        genericValidator(
          getFieldValidators(t.sieToDu, getMM1Fields(values.carSearchType), values),
          values
        )
      }
    >
      {(formikProps) => (
        <>
          <Question heading={t('question-pages.items.condition.label')}>
            <VehicleCondition />
          </Question>

          <Question heading={t('question-pages.items.fuel.label')}>
            <FuelType />
          </Question>

          {!!formikProps.values.fuelTypes?.length && (
            <Question heading={t('question-pages.items.bodystyle.label')}>
              <CarType />
            </Question>
          )}
          <ToggleObject
            id="additional-vehicle-features-toggle"
            className="c-show-more__button"
            iconClassName="c-show-more__icon"
            hidden={!showAdditionalVehicleFeatures}
            labelHidden={t('question-pages.items.additional-vehicle-features-toggle.open')}
            labelUnhidden={t('question-pages.items.additional-vehicle-features-toggle.close')}
            onClick={(hidden) => setShowAdditionalVehicleFeatures(Boolean(hidden))}
            testId="additional-vehicle-features-toggle"
            small
            iconViaCss
            iconReversed
            link
          />
          {showAdditionalVehicleFeatures && (
            <>
              <Question heading={t('question-pages.items.power.label')}>
                <Power />
              </Question>

              <Question heading={t('question-pages.items.special-equipments.label')}>
                <EquipmentAndServices items={equipmentItems} fieldName="specialEquipments" />
              </Question>
            </>
          )}
        </>
      )}
    </MatchMakerQuestionWrapper>
  );
};
